import React from "react";
import { Stack, useTheme, useMediaQuery } from "@mui/material";
import { defaultSettings } from "./MentionsOverTimeSettings";
import WidgetLayout from 'components/widgetParts/WidgetLayout';
import WidgetTitle from 'components/widgetParts/WidgetTitle';
import ISONumber from "components/formatting/ISONumber";
import { useTranslation } from "react-i18next";
import { Frequency } from "./MentionsOverTime";
import { MentionsOverTimeSettingsStateType } from "./MentionsOverTimeSettings";
import WidgetAlert, { WidgetErrorType } from "components/widgetParts/WidgetAlert";

interface MentionsOverTimeDisplayProps {
  settingsState: MentionsOverTimeSettingsStateType | {};
  widgetQueryTitle?: string;
  isPreview?: boolean;
  frequency?: Frequency;
  title?: string;
}

export default function MentionsOverTimeDisplay(props: MentionsOverTimeDisplayProps) {
  const theme = useTheme();
  const { i18n } = useTranslation();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const currentState = {...defaultSettings, ...props.settingsState};
  const title = props.title ?? `${i18n.t("widget-types.mentions-over-time.settings.default-title")}`;

  const stackWidth = props.isPreview ? (isSmallScreen ? '100%' : '400px') : '100%';
  const stackHeight = props.isPreview ? (isSmallScreen ? '100%' : '300px') : '100%';

  return (
    <Stack
      sx={{
        gap: 1,
        width: stackWidth,
        height: stackHeight
      }}>
      <WidgetLayout
        header={
          <WidgetTitle
            alignment={currentState.widgetTitleAlignment}
            settingsTitle={currentState.widgetTitle}
            defaultTitle={title}
            customTitle={`${currentState.customWidgetTitle} ${i18n.t("per-unit", { unit: props.frequency?.unit ?? "minute" })}`}
            widgetQueryTitle={props.widgetQueryTitle}
          />
        }
      >
        {!props.isPreview && !props.frequency ? (
          <WidgetAlert type={WidgetErrorType.NO_DATA} />
        ) : (
          <ISONumber
            fitToContainer
            typographyVariant="h1"
            sx={{
              alignItems: "center",
              color: currentState.color ?? theme.colors.primary.dark,
              display: "flex",
              height: "100%",
              position: "relative",
              justifyContent: currentState.alignment ?? "left",
              padding: "10px",
            }}
            number={props.frequency?.value ?? 2.5}
          />
        )}
      </WidgetLayout>
    </Stack>
  );
}
